"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileState = exports.DEFAULT_PASSWORD = exports.USER_INDEX = exports.STAFF_RELATIONSHIP_OPTIONS = exports.RELATIONSHIP_OPTIONS = void 0;
exports.RELATIONSHIP_OPTIONS = {
    Parent: 1,
    Guardian: 2,
    Spouse: 3,
    Partner: 4,
    "Medical representative": 5,
    "Power attorney": 6,
    Family: 7,
    Other: 8
};
exports.STAFF_RELATIONSHIP_OPTIONS = {
    FinancialAidAdvisor: 1,
    AdmissionAdvisor: 2,
    AcademicAdvisor: 3,
    StaffContact: 4,
    CampusDirector: 5,
    StudentServicesAdvisor: 6,
    StudentAccountsAdvisor: 7,
    Instructor: 8,
    CareerServicesAdvisor: 9
};
exports.USER_INDEX = {
    userData: "userData",
    userProfileData: "userProfileData",
    userPersonalContactData: "userPersonalContactData"
};
exports.DEFAULT_PASSWORD = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
var UserProfileState;
(function (UserProfileState) {
    UserProfileState["Prospect"] = "prospect";
    UserProfileState["Applicant"] = "applicant";
    UserProfileState["Student"] = "student";
    UserProfileState["Alumni"] = "alumni";
    UserProfileState["Employee"] = "employee";
    UserProfileState["ExEmployee"] = "ex-employee";
    UserProfileState["Active"] = "active";
    UserProfileState["Inactive"] = "inactive";
    UserProfileState["Supervisor"] = "supervisor";
})(UserProfileState = exports.UserProfileState || (exports.UserProfileState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJzZXJ2ZXIvY29tbW9uL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2hDLE1BQU0sRUFBRSxDQUFDO0lBQ1QsUUFBUSxFQUFFLENBQUM7SUFDWCxNQUFNLEVBQUUsQ0FBQztJQUNULE9BQU8sRUFBRSxDQUFDO0lBQ1Ysd0JBQXdCLEVBQUUsQ0FBQztJQUMzQixnQkFBZ0IsRUFBRSxDQUFDO0lBQ25CLE1BQU0sRUFBRSxDQUFDO0lBQ1QsS0FBSyxFQUFFLENBQUM7Q0FDWCxDQUFBO0FBRVksUUFBQSwwQkFBMEIsR0FBRztJQUN0QyxtQkFBbUIsRUFBRSxDQUFDO0lBQ3RCLGdCQUFnQixFQUFFLENBQUM7SUFDbkIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLENBQUM7SUFDZixjQUFjLEVBQUUsQ0FBQztJQUNqQixzQkFBc0IsRUFBRSxDQUFDO0lBQ3pCLHNCQUFzQixFQUFFLENBQUM7SUFDekIsVUFBVSxFQUFFLENBQUM7SUFDYixxQkFBcUIsRUFBRSxDQUFDO0NBQzNCLENBQUE7QUFFWSxRQUFBLFVBQVUsR0FBRztJQUN0QixRQUFRLEVBQUUsVUFBVTtJQUNwQixlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLHVCQUF1QixFQUFFLHlCQUF5QjtDQUNyRCxDQUFBO0FBQ1ksUUFBQSxnQkFBZ0IsR0FBRyxnRUFBZ0UsQ0FBQTtBQUVoRyxJQUFZLGdCQVVYO0FBVkQsV0FBWSxnQkFBZ0I7SUFDeEIseUNBQXFCLENBQUE7SUFDckIsMkNBQXVCLENBQUE7SUFDdkIsdUNBQW1CLENBQUE7SUFDbkIscUNBQWlCLENBQUE7SUFDakIseUNBQXFCLENBQUE7SUFDckIsOENBQTBCLENBQUE7SUFDMUIscUNBQWlCLENBQUE7SUFDakIseUNBQXFCLENBQUE7SUFDckIsNkNBQXlCLENBQUE7QUFDN0IsQ0FBQyxFQVZXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBVTNCIn0=